/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import { ActivityLogType } from 'cio/utils/activity-log-types';
import { task, timeout } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import Ember from 'ember';
import config from 'cio/config/environment';

interface CampaignOverviewPageWebhookActivityCardArgs {
  campaign: CampaignModel;
}

const MAX_WEBHOOKS_TO_DISPLAY_COUNT = 5;

export default class CampaignOverviewPageWebhookActivityCard extends Component<CampaignOverviewPageWebhookActivityCardArgs> {
  @service store!: DS.Store;

  pollForWebhooks = task({ restartable: true }, async () => {
    //eslint-disable-next-line no-constant-condition
    while (true) {
      await this.fetchRecentWebhooks.perform();

      if (Ember.testing) {
        break;
      }

      await timeout(config.APP.shortPollingDelay);
    }
  });

  fetchRecentWebhooks = task({ drop: true }, async () => {
    return (
      await this.store.query('log', {
        type: ActivityLogType.WebhookEvent,
        name: this.args.campaign.id,
      })
    )
      .toArray()
      .filter((log) => log.timestamp >= this.args.campaign.firstStarted)
      .slice(0, MAX_WEBHOOKS_TO_DISPLAY_COUNT);
  });
}
